
import PorrCase from "../Components/References/PorrCase";
import Footer from "../Components/Footer";

const Porr = () => {
    return (
      <div>
        <PorrCase />
        <Footer />
      </div>
    );
  };
  
  export default Porr;